import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { isAdminUser } from "../helper/userDisplay";

const PrivateRoute = (props) => {
  const user = useSelector((data) => data.userDataSlice.userData);

  // Match the login gate: only an admin user may render the dashboard. This
  // re-validates on every load, so a stale persisted session or a downgraded
  // role can't keep someone in the shell.
  return isAdminUser(user) ? <>{props.children}</> : <Navigate to={"/login"} />;
};

export default PrivateRoute;
